module.exports = __webpack_public_path__ + "media/images/farey/social/YouTube-47ef0b1088026817ab92fb64f71ce255.png";